import { BaseClient } from '../BaseClient';
import { CallWindowJobCap, CallWindowJobCapList } from '../compiled-protos/call_window_job_cap';
import { CallWindowJobCapServiceClient } from '../compiled-protos/call_window_job_cap.client';
import { Empty } from '../compiled-protos/common';

class CallWindowJobCapClient extends BaseClient {
  self: CallWindowJobCapServiceClient;

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new CallWindowJobCapServiceClient(this.transport);
  }

  public async Create(req: CallWindowJobCap): Promise<CallWindowJobCap | undefined> {
    let res = CallWindowJobCap.create();
    try {
      res = await this.self.createCallWindowJobCap(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async Get(req: CallWindowJobCap): Promise<CallWindowJobCap | undefined> {
    let res = CallWindowJobCap.create();
    try {
      res = await this.self.getCallWindowJobCap(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async BatchGet(req: CallWindowJobCap): Promise<CallWindowJobCapList | undefined> {
    let res = CallWindowJobCapList.create();
    try {
      res = await this.self.batchGetCallWindowJobCap(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async Update(req: CallWindowJobCap): Promise<CallWindowJobCap | undefined> {
    let res = CallWindowJobCap.create();
    try {
      res = await this.self.updateCallWindowJobCap(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  public async Delete(req: CallWindowJobCap): Promise<Empty | undefined> {
    let res = Empty.create();
    try {
      res = await this.self.deleteCallWindowJobCap(req, this.getMetaData()).response;
    } catch (err) {
      console.log(err);
      return;
    }
    return res;
  }

  // Helper method to load job caps with filtering
  public loadCallWindowJobCaps = async ({
    filter,
  }: LoadCallWindowJobCapsRequest): Promise<CallWindowJobCapList> => {
    const req = CallWindowJobCap.create();
    req.pageNumber = -1;

    if (filter.departmentId !== undefined) {
      req.departmentId = filter.departmentId;
    }
    if (filter.eventTradeId !== undefined) {
      req.eventTradeId = filter.eventTradeId;
    }
    if (filter.jobTypeId !== undefined) {
      req.jobTypeId = filter.jobTypeId;
    }
    if (filter.isActive !== undefined) {
      req.isActive = filter.isActive;
    }
    // Sunday is day 0, which the server's query builder cannot tell apart from "unset" -- it
    // only writes a predicate for a non-zero field or one named in the field mask. Without the
    // mask, filtering to Sunday silently returns every day instead.
    if (filter.dayOfWeek !== undefined) {
      req.dayOfWeek = filter.dayOfWeek;
      req.fieldMask = [...req.fieldMask, 'DayOfWeek'];
    }

    const result = await this.BatchGet(req);
    return result || CallWindowJobCapList.create();
  };
}

export { CallWindowJobCapClient, CallWindowJobCap, CallWindowJobCapList };

export type LoadCallWindowJobCapsRequest = {
  filter: CallWindowJobCapFilter;
};

export type CallWindowJobCapFilter = {
  departmentId?: number;
  /** Ignored by the server when 0. */
  eventTradeId?: number;
  /** 0=Sunday .. 6=Saturday. Omit to load every day and narrow client-side. */
  dayOfWeek?: number;
  jobTypeId?: number;
  isActive?: boolean;
};
